import { cn } from '../utils/cn';

interface SwitchInputProps {
  label: string;
  name: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export default function SwitchInput({ label, name, checked = false, onChange, disabled, className }: SwitchInputProps) {
  return (
    <label className={cn('flex items-center justify-between cursor-pointer', disabled && 'opacity-50 cursor-not-allowed', className)}>
      <span className="text-sm text-content-secondary">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => !disabled && onChange?.(!checked)}
        className={cn(
          'relative inline-flex h-5 w-9 items-center rounded-full transition-colors',
          checked ? 'bg-primary' : 'bg-content-muted'
        )}
      >
        <span
          className={cn(
            'inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform',
            checked ? 'translate-x-4.5' : 'translate-x-0.5'
          )}
        />
      </button>
    </label>
  );
}
